import { InverseHeader } from '@jouzen/ecom-components';

import { EventType } from '@/analytics/types';
import { useHubspotFormsContext } from '@/app/[locale]/business/_contexts/HubspotFormsContext';
import LandingPageHero from '@/app/components/LandingPage/LandingPageHero';
import { BUSINESS_PATHNAME } from '@/app/consts/pathnames';

import { HUBSPOT_SELECTION_MODAL_ID } from '../HubspotSelectionModal';

const BusinessHero = () => {
  const { setActiveModal } = useHubspotFormsContext();

  const handleCtaClick = () => {
    setActiveModal(HUBSPOT_SELECTION_MODAL_ID);

    void window.ouraAnalytics.track(EventType.LinkClicked, {
      cta: 'request_a_quote',
      location: 'hero',
      path: BUSINESS_PATHNAME,
    });
  };

  return (
    <InverseHeader enter>
      <LandingPageHero
        backgroundImage={{
          localizedAlt: 'man_typing_alt',
          srcSet: [
            {
              media: '(max-width: 1024px)',
              src: 'business/typing-oreo-mobile',
            },
            {
              media: '(min-width: 1025px)',
              src: 'business/typing-oreo',
            },
          ],
        }}
        backgroundProps={{
          color: 'slate-600',
          gradients: [],
        }}
        copy="business_hero_description"
        cta={{
          label: 'business_hero_action',
          onClick: handleCtaClick,
          variant: 'secondary-light',
        }}
        data-cy="business-hero"
        textColor="text-sandstone-200"
        title="business_hero_title"
      />
    </InverseHeader>
  );
};

export default BusinessHero;
